export var CustomComboBoxDataTids = {
  comboBoxView: 'ComboBoxView__root'
};